<template>
  <div>
   <header>
          <div class="headerOne">
               <i class="el-icon-arrow-left" @click="$router.go(-1)"></i>
              <!-- <img src="../../assets/images/returnOne.png" @click="$router.go(-1)"> -->
              <span class="buss">支付密码设置</span>
          </div>
      </header>
      <div class="oneId">
          <ul>
              <li>
                  <span>会员身份证:</span>
                  <input type="text" maxlength="18" placeholder="请输入18位身份证号"  v-model="idCard">
              </li>
              <li>
                  <span>支付密码 :</span>
                  <input type="number" placeholder="设置6位数字支付密码" maxlength="6" v-model="passTwo">
                    <!-- <div class="twoId">支付密码不能重复,连续的数字</div> -->
              </li>
          </ul>
      </div>
    
        <div class="sub" @click="successPay">
                完 成
          </div>
 
  </div>
</template>
<script>
　　import md5 from 'js-md5'
    import { DatetimePicker, Popup, Toast, Indicator, Radio } from "mint-ui";
    export default{
        data(){
            return{
                msg:"支付",
                idCard:"",
                passTwo:"",
                passTwoo:"",
                idCardo:""
            }
        },
          computed:{
                wsWbsocket(){
                return this.$store.state.wsWbsocket
                }
       },
        methods:{
            successPay(){
                // 身份证号的合法性
                 var regThree = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
                    //输入的身份证号码
                    if (regThree.test(this.idCard)) {
                        this.idCardo=this.idCard;
                            var passOne=/^\d{6}$/;
                            if (passOne.test(this.passTwo)) {
                                this.passTwoo=this.passTwo   
                                       console.log( this.passTwoo, this.idCardo)
                   var md56=md5(this.passTwoo)
                    console.log(md56)
                     var status='"'+'status'+'":'+'"'+0+'"'
                    var identity='"'+'identity'+'":'+'"'+this.idCardo+'"'
                    var newPass='"'+'password'+'":'+'"'+md56+'"'  //支付密码 
                  
               ws.send('{"action":"UserPasswdByUid",'+status+','+identity+','+newPass+'}');
                    ws.onmessage = (res)=> 
               { 

                    var obj = JSON.parse(res.data);
                    console.log(obj);
                    if(obj.s==0){
                        console.log(obj)
                              Toast({
                                message: '设置成功',
                                position: 'top',
                                duration: 2000
                                });
                            // this.$router.push({name:"setting"})
                    }
                    else if(obj.s==1029)
                    {
                            Toast({
                                message: '身份证号码跟预留号码不一致',
                                position: 'top',
                                duration: 2000
                                });
                    }
                     else if(obj.s==1030)
                    {
                        // Toast({
                        //         message: '身份证号码不能为空',
                        //         position: 'top',
                        //         duration: 1000
                        //         });
                    }
                       else if(obj.s==1007)
                    {
                        Toast({
                                message: '密码修改无变化',
                                position: 'top',
                                duration: 1000
                                });
                    }
               }             
                                } 
                                
                            else 
                                {
                                    Toast({
                                        message: '请输入有效的支付密码',
                                        position: 'top',
                                        duration: 2000
                                        });
                                }
                    } else {
                        Toast({
                                message: '请输入有效的身份证',
                                position: 'top',
                                duration: 1000
                                });
                                                }
                 
            }
        }
    }
</script>
<style scoped>
.el-icon-arrow-left{
    font-size: 0.7rem;
    line-height:1.6rem;
     margin-left: 0.2rem
}
 header{
    height:1.6rem;
    width: 100%;
    border-bottom: 1px solid rgba(0,0,0,0.20);
    position: relative;
}
 .headerOne{
     font-size: 0;  
     }
 .headerOne img{
    display: inline-block;
    margin-top: 0.3rem
 }
  .headerOne img:nth-child(1){
      margin-left: 0.2rem
  }
  .headerOne .buss{
      display: inline-block;
      font-size: 0.55rem;
        position:absolute;
        left:50%;
        top:50%;
        transform: translate(-50%,-50%);
  }
  .oneId ul li{
      color: rgba(0,0,0,0.90);
  
      margin-top: 0.5rem;
      height: 1.7rem;
  }
  .oneId ul li span{
      font-size: 0.55rem !important
  }
  .twoId{
      font-size: 0.45rem;
      color: rgba(0,0,0,0.50);
      margin: 0.1rem 0 0 2.5rem;
      padding-left: 0.5rem
  }
  .oneId ul li span{
      font-size: 0.55rem;
      margin-left: 0.3rem
  }
  .oneId ul li input{
      margin-left: 0.3rem;
      border: none;
      outline: none;
      border-bottom: 1px solid rgba(0,0,0,0.20);
      height: 0.8rem;
      width: 5.8rem;
      font-size: 0.55rem
  }
  input::-webkit-input-placeholder {  

        font-size: 0.55rem;
                color: rgba(0, 0, 0, 0.5)
} 
.sub {
        color: white;
      font-size: 0.55rem;
      width: 90%;
      background-image: linear-gradient(to right, #2EA4B0, #06789D);
      margin: 0 auto;
      margin-top: 0.8rem;
      height:1.2rem;
      border-radius: 15px;
      text-align: center;
      line-height:1.2rem
    }
</style>


// WEBPACK FOOTER //
// src/components/change/pay.vue